import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { resolveInboxTab } from '@dataroom/core/inbox';
import { INBOX_VIEWS, LEGACY_INBOX_TABS } from '@dataroom/core/search-enums';
import { UnifiedInbox } from '../../features/inbox/UnifiedInbox';
export const Route = createFileRoute('/_app/inbox')({
  validateSearch: z.object({
    tab: z
      .enum([...INBOX_VIEWS, ...LEGACY_INBOX_TABS])
      .optional()
      .catch(undefined),
    item: z.string().optional(),
    full: z.coerce.boolean().optional(),
    create: z.coerce.boolean().optional(),
    saved: z.uuid().optional(),
    record: z.uuid().optional(),
    task: z.string().optional(),
    view: z.string().optional(),
  }),
  component: function InboxRoute() {
    const s = Route.useSearch();
    // A link to the former Team or Watching tab opens For you with that assignee.
    const legacy = s.tab ? resolveInboxTab(s.tab, { assignee: 'me' }) : undefined;
    return (
      <UnifiedInbox
        full={s.full}
        key={s.saved ?? 'inbox'}
        saved={s.saved}
        createRequested={s.create}
        recordFilter={s.record}
        assignee={legacy && legacy.filters.assignee !== 'me' ? legacy.filters.assignee : undefined}
        tab={legacy?.tab ?? (s.view === 'updates' ? 'updates' : s.view === 'history' ? 'done' : 'for-you')}
        item={s.task ? `task:${s.task}` : s.item}
      />
    );
  },
});
